import { render, staticRenderFns } from "./TransactionToEnforcementTransactionForm.vue?vue&type=template&id=75c41cad"
import script from "./TransactionToEnforcementTransactionForm.vue?vue&type=script&lang=js"
export * from "./TransactionToEnforcementTransactionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports